import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal } from '../../modal';
import passwordFormMessages from '../resetPasswordForm.messages';
import messages from './resetPasswordFormSuccess.messages';
import { Description } from '../resetPasswordForm.styles';

export class ResetPasswordFormSuccess extends PureComponent {
  static propTypes = {
    intl: PropTypes.object,
    email: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  render() {
    return (
      <Modal onClose={this.props.onClose} title={this.props.intl.formatMessage(passwordFormMessages.title)}>
        <Description>
          <FormattedMessage
            {...messages.afterSubmitDescription}
            values={{
              email: this.props.email,
            }}
          />
        </Description>
      </Modal>
    );
  }
}
